export enum ClientStatus {
  ATIVO = "ATIVO",
  CANCELADO = "CANCELADO",
  COBRANCA = "COBRANCA",
  INADIMPLENTE = "INADIMPLENTE",
  INATIVO = "INATIVO",
}

export const isBlockedCard = (status?: string) => {
  if (!status) return true;
  return [
    "CANCELAMENTO_EXPERIENCIA",
    "CANCELAMENTO_SOLICITACAO",
    "CANCELAMENTO_INATIVIDADE",
    "CANCELAMENTO_PROPOSTA",
    "CANCELADO",
  ].includes(status);
};
